// extracted by mini-css-extract-plugin
module.exports = {"buttonClass":"MoveToTopButton_buttonClass_2cFgx"};